import { render, staticRenderFns } from "./ProvinceQuebecFlag.vue?vue&type=template&id=81c0ae70"
import script from "./ProvinceQuebecFlag.vue?vue&type=script&lang=js"
export * from "./ProvinceQuebecFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports